// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3039":"a64801a5","3068":"86deaab0","5511":"e5db9121","8688":"c558803c","9382":"a64801a5"}[chunkId] + ".chunk.css";
};